import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import ChatWidget from "./ChatWidget";
import "./index.css";

const container = document.getElementById("hotbox-widget-root");
if (container) {
  createRoot(container).render(
    <StrictMode>
      <ChatWidget />
    </StrictMode>
  );
}
